import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { LightningModalTypes } from '../../../../core/classes/modal-types.enum';

@Component({
  selector: 'app-offline-request-dialog',
  templateUrl: './offline-request-dialog.component.html',
  styleUrls: ['./offline-request-dialog.component.scss'],
  standalone: false
})
export class OfflineRequestDialogComponent {
  // Input
  public jrfReference: string = null;
  public text = 'The offline booking request has been sent.';

  constructor(public activeModal: NgbActiveModal) {}
}

LightningModalTypes.OfflineRequestDialogComponent.component = OfflineRequestDialogComponent;
